import { Action, configureStore, getDefaultMiddleware, ThunkAction } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import applicationReducer from '../../core_web/store/Application.store';
import logisticaReducer from './logistica.store';
import agendamentoReducer from './agendamento.store';
import contratosCarregamentoReducer from './contratos.store';
import relatorioReducer from './relatorios.store';
import solicitacoesPagamentoReducer from './solicitacaoPagamento.store';
import veiculoReducer from './veiculo.store';

export const store = configureStore({
  reducer: {
    application: applicationReducer,
    logistica: logisticaReducer,
    agendamento: agendamentoReducer,
    contratos: contratosCarregamentoReducer,
    relatorio: relatorioReducer,
    solicitacoes: solicitacoesPagamentoReducer,
    veiculos: veiculoReducer
  },
  middleware: getDefaultMiddleware({
    serializableCheck: false,
    immutableCheck: false
  })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk = ThunkAction<void, RootState, null, Action<string>>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
